<template>
  <button class="img-button" :class="{disabled:disabled}" @click="$emit('click')">
    <img :src="imgSrc" />
  </button>
</template>

<script>
export default {
  name: "img-button",
  props: ["src","disabled"],
  computed: {
    imgSrc() {
      return require("../assets/images/" + this.src);
    },
  },
};
</script>

<style lang="scss">
.img-button {
  border: none;
  padding: 0;
  cursor: pointer;

  img {
    width: 30px;
    height: 30px;
    object-fit: cover;
    object-position: 0 0;
  }

  &:hover,&.disabled {
    img {
      object-position: 100% 0;
    }
  }

  &.disabled {
      cursor: not-allowed;
  }
}
</style>
